'use client';

import { SDKResponse } from '@commercetools/frontend-sdk';
import { PageResponse } from '@commercetools/frontend-sdk/lib/types/api/page';
import Toaster from 'components/gruenland/atoms/toaster';
import { AccountProvider } from 'context/account';
import AddToCartOverlayProvider from 'context/add-to-cart-overlay';
import { Translations } from 'types/i18n';
import BlockScrollProvider from './blockScroll';
import { CategoryProvider } from './category';
import I18nProvider from './i18n';
import { SWRProvider } from './swr';
import TracingProvider from './tracing';
import { GetAccountActionReturn } from '../sdk/composable-commerce/types/actions/AccountActions';

interface ProvidersProps {
  translations: Translations;
  accountResult?: SDKResponse<GetAccountActionReturn>;
  page: SDKResponse<PageResponse>;
}

export const Providers = ({ translations, accountResult, page, children }: React.PropsWithChildren<ProvidersProps>) => {
  return (
    <TracingProvider page={page}>
      <I18nProvider translations={translations}>
        <BlockScrollProvider>
          <SWRProvider value={{ fallback: { '/action/account/getAccount': accountResult } }}>
            <AddToCartOverlayProvider>
              <AccountProvider>
                <CategoryProvider>{children}</CategoryProvider>
              </AccountProvider>
            </AddToCartOverlayProvider>
            <Toaster />
          </SWRProvider>
        </BlockScrollProvider>
      </I18nProvider>
    </TracingProvider>
  );
};
